import { dfetchFromParams, type FetchParams } from "src/utils/dfetch.ts";
import { requestsSemaphore, runWithSignal } from "./requestsSemaphore";

export const queryFnWrapper = async <T>(props: FetchParams): Promise<T> =>
  runWithSignal(requestsSemaphore, props.signal, async () =>
    dfetchFromParams<T>(props)
  );
